<template>
    <v-dialog v-model="mostrar" persistent max-width="900" scrollable>
		<v-card max-height="600px" max-width="900" class="mx-auto">
			<v-card-title class="primary white--text">{{evento.titulo}}</v-card-title>
            <v-card-text class="pt-4">
            <h3 slot="header"></h3>
			<div v-if="!cadastrarDoacao" slot="body" :class="{mensagem: this.doacoes.itens.length == 0}">
				<div class="itens-doacao p-3">
					<v-data-table dense fixed-header class="table-item" :items="doacoes.itens" :headers="doacoes.headers" :items-per-page="5">
						<template v-slot:item.action="{ item }">
						<v-btn text color="primary" id="btn-doacao" :disabled="item.qtd_pendente == 0" title="Doar Item" variant="success" @click="doarItem(item)">
								Doar Item
							</v-btn>
						</template>
					</v-data-table>
				</div>
			</div>
			<div v-else class="itens-doacao p-3" slot="body">
				<v-container>
					<v-row>
						<v-col cols="6" md="3">
							<v-text-field type="number" label="Quantidade" :max="itemDoacao.qtd_pendente" min="1" id="itemDoacao-doacao" v-model="itemDoacao.qtd_doacao"></v-text-field>
						</v-col>
					</v-row>
				</v-container>
				
			</div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
				<v-btn v-if="cadastrarDoacao" text color="primary" @click="confirmarDoacao()">Confirmar Doacao</v-btn>
				<v-btn v-if="cadastrarDoacao" text color="primary" @click="cancelarDoacao(evento.id)">Cancelar</v-btn>
				<v-btn v-else text color="primary" @click="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>    
</template>

<script>
    import {baseApiUrl, showError, showSuccess} from '@/config/global'
    import axios from 'axios'
    import { mapState } from 'vuex'
    
export default{
    props:['mostrar', 'evento','doacoes'],
    computed:{
            ... mapState(['user']),
		},
    data(){
        return{
            cadastrarDoacao: false,
            itemDoacao: {},
            
        }
    },
    methods:{
        fechar(){
            this.$emit('fecharDoacoes')
        },

        doarItem(item){
				
				this.itemDoacao.id_item = item.id_item
				this.itemDoacao.qtd_pendente = item.qtd_pendente
				this.itemDoacao.qtd_doacao = 0
				
				this.cadastrarDoacao = true
			},

			cancelarDoacao(){
				if(this.itemDoacao.id){
					this.atualizaItemCancelado(this.itemDoacao.id)
				}else{
					this.cadastrarDoacao = false
				}
			},

			atualizaItemCancelado(id){
				const url = `${baseApiUrl}/itensEventos/readOne.php?id_item=${id}`
				
				axios.get(url)
				.then(res => {
					
					if(res.data.codigo == '01'){
						
						let idx = this.doacoes.itens.findIndex((v) => {
							return v.id == res.data.dados[0].id
						})

						this.doacoes.itens[idx] = res.data.dados[0]
						this.doacoes.itens[idx].qtd_doacao = this.doacoes.itens[idx].quantidade - this.doacoes.itens[idx].qtd_pendente
						this.cadastrarDoacao = false
						
					}else{
						showError(res.data.mensagem)
					}
				})
            },
            
            confirmarDoacao(){
				const url = `${baseApiUrl}/itensDoacoes/registrar.php`
				
				this.itemDoacao.id_iniciado = this.user.iniciado
                if(this.itemDoacao.qtd_doacao > 0){
                    axios.post(url, this.itemDoacao)
                    .then(res => {
                        
                        if(res.data.codigo == '01'){
                            
                            let idx = this.doacoes.itens.findIndex((v) => {
                                return v.id_item == this.itemDoacao.id_item
                            })

                            this.doacoes.itens[idx].qtd_pendente = this.itemDoacao.qtd_pendente - this.itemDoacao.qtd_doacao
                            
                            showSuccess(res.data.mensagem)
                            this.cadastrarDoacao = false
                            
                        }else{
                            
                            showError(res.data.mensagem)
                        }
                    })
                }else{
                    showError("Quantidade precisa ser maior que zero")
                }

			},

    },

    watch:{
			'itemDoacao.qtd_doacao'(){
				this.itemDoacao.qtd_pendente = this.itemDoacao.quantidade - this.itemDoacao.qtd_doacao
            },
		},
}
</script>

<style scoped>

</style>